import React from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import { Form } from 'react-final-form'
import I18n from 'translations/i18n'
import { TextInputField } from 'components/final-form'
import { Text, Button, Spacer } from '@jisr-hr/design-system'
import classNames from 'classnames'
import { labels } from 'utils/whitelabel'
import { required } from 'components/global/form/FormValidations'

const LoginForm = ({ fetching, history, showCaptcha, onCaptchaChange, ...props }) => (
  <Form
    onSubmit={props.onSubmit}
    validate={(vals) => ({
      login: required(vals.login),
      password: required(vals.password),
    })}
  >
    {({ handleSubmit, submitting }) => (
      <form
        onSubmit={handleSubmit}
        className={classNames('login-form', labels.name === 'Maken' && 'maken-form')}
      >
        <TextInputField
          testId="login-username"
          name="login"
          type="text"
          label={I18n.t('username')}
          style={{ width: '100%' }}
        />
        <Text
          as="span"
          data-testid="forgot-password"
          typography="caption12"
          onClick={() => history.push('/forgot_password')}
          className="forget-link"
        >
          {I18n.t('forgot_password')}
        </Text>
        <TextInputField
          testId="login-password"
          name="password"
          type="password"
          label={I18n.t('password')}
          style={{ width: '100%' }}
        />
        {showCaptcha && import.meta.env.REACT_APP_RECAPTCHA_KEY && (
          <ReCAPTCHA
            style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}
            sitekey={import.meta.env.REACT_APP_RECAPTCHA_KEY}
            onChange={onCaptchaChange}
          />
        )}
        <Spacer height="8px" />
        <Button
          data-testid="login-button"
          disabled={fetching || submitting}
          variant="primary"
          label={I18n.t('login')}
          type="submit"
          className={classNames(
            'login-btn-full',
            labels.name === 'Maken' && 'maken-btn',
            labels.name === 'Ahad' && 'ahad-btn',
          )}
          onClick={handleSubmit}
        />
      </form>
    )}
  </Form>
)

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  showCaptcha: PropTypes.bool,
  onCaptchaChange: PropTypes.func,
  history: PropTypes.shape().isRequired,
}

export default LoginForm
